import { Settings } from '../../../settings/components/Settings';

const SettingsPage = () => {
    return <Settings />;
};

export default SettingsPage;
